"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AKAMAI_SIZES = {
    '40': 'xxu',
    '80': 'xu',
    '160': 'u',
    '300': 'xxxs',
    '400': 'xxs',
    '500': 'xs',
    '600': 's',
    '700': 'm',
    '750': 'l',
    '900': 'xl',
    '1100': 'xxl',
    '1400': 'xxxl'
};
var SIZE_NUMBERS = Object.keys(AKAMAI_SIZES).map(function (size) { return parseInt(size); });
/**
 * Utility for calculating image src.
 */
var ImageUtility = /** @class */ (function () {
    function ImageUtility() {
    }
    /**
     * Returns Akamai URL for an image.
     *
     * @param url URL of image.
     * @param width Width in pixels.
     * @returns Akamai URL.
     */
    ImageUtility.getAkamaiImageUrl = function (url, width) {
        return url + this.getAkamaiQueryString(width);
    };
    /**
     * Returns an Akamai query string based on size.
     *
     * @param width Width of the image in px.
     * @returns Query string.
     */
    ImageUtility.getAkamaiQueryString = function (width) {
        return "?f=" + this.getAkamaiSize(width);
    };
    /**
     * Get Akamai formatted size.
     *
     * @param width Image width.
     * @returns Size.
     */
    ImageUtility.getAkamaiSize = function (width) {
        for (var _i = 0, SIZE_NUMBERS_1 = SIZE_NUMBERS; _i < SIZE_NUMBERS_1.length; _i++) {
            var akamaiSize = SIZE_NUMBERS_1[_i];
            if (width <= akamaiSize) {
                return AKAMAI_SIZES[akamaiSize.toString()];
            }
        }
        return AKAMAI_SIZES[SIZE_NUMBERS[SIZE_NUMBERS.length - 1].toString()];
    };
    return ImageUtility;
}());
exports.default = ImageUtility;
//# sourceMappingURL=ImageUtility.js.map